import React, { useState, useEffect} from 'react';
import { Grid, Typography, Button, Box, Container, Paper } from '@mui/material';
import backgroundImage from '../assets/img/banner.jpg';
import useStyles from '../styles/styles';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import {calcEst, showEst, optionsRequired, FONT_FAMILY} from '../common/sharedFunctions';
import {colors as col, modernColors} from "../components/Theme/WebTheme"
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ShieldIcon from '@mui/icons-material/Shield';

const Hero = (props) => {
  const classes = useStyles();
  const { t, i18n  } = useTranslation();
  const isRTL = i18n.dir();
  const navigate = useNavigate();
  const role = props.role;
  const [loggedIn, setLoggedIn] = useState(false);
  const auth = useSelector(state => state.auth);
  const settings = useSelector(state => state.settingsdata.settings);

  useEffect(()=>{
    if(auth.profile && auth.profile.uid){
      setLoggedIn(true);
    }else{
      setLoggedIn(false);
    }
  },[auth.profile]);

  const features = [
    {
      icon: <LocalShippingIcon sx={{ fontSize: 32, color: modernColors.primary }} />,
      text: t('product_section_1')
    },
    {
      icon: <CheckCircleOutlineIcon sx={{ fontSize: 32, color: modernColors.primary }} />,
      text: t('product_section_2')
    },
    {
      icon: <ShieldIcon sx={{ fontSize: 32, color: modernColors.primary }} />,
      text: t('product_section_3')
    }
  ];

  return (
    <Box 
      sx={{ 
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        marginTop: '40px'
      }}
    >
      {/* Arkaplan Görüntüsü */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          zIndex: 0,
          '&::after': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            backdropFilter: 'blur(2px)',
            zIndex: 1
          }
        }}
      />
      
      {/* Kırık Şekil Bölücü */}
      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: '150px',
          zIndex: 2,
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: '150px',
            backgroundColor: '#fff',
            clipPath: 'polygon(0 100%, 100% 100%, 100% 40%, 65% 65%, 30% 35%, 0 60%)'
          }
        }}
      />
      
      {/* İçerik */}
      <Container sx={{ position: 'relative', zIndex: 3 }}>
        <Grid container spacing={5} alignItems="center">
          {/* Sol Taraf - Başlık ve Metin */}
          <Grid item xs={12} md={7}>
            <Box
              sx={{
                position: 'relative',
                p: { xs: 3, md: 0 },
                mb: { xs: 5, md: 0 }
              }}
            >
              <Typography 
                variant="h2" 
                sx={{
                  fontWeight: 800, 
                  color: '#fff',
                  textShadow: '0 2px 10px rgba(0,0,0,0.3)',
                  fontFamily: FONT_FAMILY,
                  fontSize: { xs: '2.5rem', md: '3.5rem' },
                  mb: 2,
                  position: 'relative'
                }}
              >
                {t('book_your_title')}
              </Typography>
              
              <Typography 
                variant="h6" 
                sx={{
                  color: 'rgba(255,255,255,0.9)',
                  fontFamily: FONT_FAMILY,
                  fontWeight: 400,
                  fontSize: { xs: '1rem', md: '1.1rem' },
                  lineHeight: 1.7,
                  mb: 4,
                  maxWidth: '600px',
                  textShadow: '0 1px 2px rgba(0,0,0,0.2)',
                }}
              >
                {t('about_us_content2')}
              </Typography>
              
              <Button
                variant="contained"
                onClick={(e) => { 
                  e.preventDefault();
                  if(loggedIn){
                    navigate(((role && role === 'driver') || (calcEst && !showEst && !optionsRequired && (role === 'admin' || role === 'fleetadmin'))) ? '/bookings' : '/addbookings')
                  } else {
                    navigate('/login')
                  }
                }}
                sx={{ 
                  py: 1.8,
                  px: 4,
                  borderRadius: '50px',
                  backgroundColor: modernColors.primary,
                  color: modernColors.textPrimary,
                  fontFamily: FONT_FAMILY,
                  fontWeight: 700,
                  fontSize: '1rem',
                  textTransform: 'none',
                  boxShadow: '0 10px 20px rgba(255, 193, 7, 0.3)',
                  '&:hover': {
                    backgroundColor: '#FFB300',
                    boxShadow: '0 12px 25px rgba(255, 193, 7, 0.4)',
                    transform: 'translateY(-2px)',
                  },
                  transition: 'all 0.3s ease',
                  mr: 2
                }}
                endIcon={<ArrowForwardIcon />}
              >
                {role === 'driver' || (calcEst && !showEst && !optionsRequired && (role === 'admin' || role === 'fleetadmin')) ? t('info') : t('book_your_ride_menu')}
              </Button>
              
              {!loggedIn && (
                <Button
                  variant="outlined"
                  onClick={() => navigate('/login')}
                  sx={{ 
                    py: 1.8,
                    px: 4,
                    borderRadius: '50px',
                    borderColor: 'rgba(255,255,255,0.7)',
                    color: '#fff',
                    fontFamily: FONT_FAMILY,
                    fontWeight: 600,
                    fontSize: '1rem',
                    textTransform: 'none',
                    '&:hover': {
                      borderColor: '#fff',
                      backgroundColor: 'rgba(255,255,255,0.1)',
                    },
                    transition: 'all 0.3s ease',
                  }}
                >
                  {t('login_signup')}
                </Button>
              )}
            </Box>
          </Grid>
          
          {/* Sağ Taraf - Özellikler Kartı */}
          <Grid 
            item 
            xs={12} 
            md={5}
            sx={{
              display: { xs: 'none', md: 'block' }
            }}
          >
            <Paper
              elevation={3}
              sx={{
                borderRadius: '16px',
                p: 4,
                backgroundColor: 'rgba(255,255,255,0.9)',
                backdropFilter: 'blur(10px)',
                boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
                transform: 'translateY(-20px)',
                position: 'relative',
                overflow: 'hidden',
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '5px',
                  height: '100%',
                  background: `linear-gradient(to bottom, ${modernColors.primary}, ${modernColors.hover})`,
                  borderTopLeftRadius: '16px',
                  borderBottomLeftRadius: '16px'
                }
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontFamily: FONT_FAMILY,
                  fontWeight: 700,
                  color: modernColors.textPrimary,
                  mb: 3
                }}
              >
                {settings?.appName || ''} 
              </Typography>
              
              <Box component="ul" sx={{ pl: 0, listStyle: 'none' }}>
                {features.map((feature, index) => (
                  <Box 
                    component="li" 
                    key={index}
                    sx={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      mb: 3,
                      p: 2,
                      borderRadius: '10px',
                      backgroundColor: index % 2 === 0 ? 'rgba(255, 193, 7, 0.08)' : 'transparent',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        backgroundColor: 'rgba(255, 193, 7, 0.15)',
                        transform: 'translateX(5px)'
                      }
                    }}
                  >
                    <Box 
                      sx={{ 
                        mr: 2,
                        mt: 0.5,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 50,
                        height: 50,
                        borderRadius: '12px',
                        backgroundColor: modernColors.secondary,
                        boxShadow: `0 5px 15px ${modernColors.primary}30`
                      }}
                    >
                      {feature.icon}
                    </Box>
                    <Typography
                      variant="body1"
                      sx={{
                        fontFamily: FONT_FAMILY,
                        color: modernColors.textSecondary,
                        fontWeight: 400,
                        lineHeight: 1.6
                      }}
                    >
                      {feature.text}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Hero;